import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useForm } from '../../../Store/uses/useForm';
import { Record } from '../../../config/Record/RecordEntity';
import { t, numStr } from '../../../components/common/Translate';
import { Auth } from '../../../config/configuration/react';
import { hideTabs } from '../../../Utils/hideTabs';
import { dmsStatusList, REACT_APP_API } from '../../../config';
import { currencySign } from '../../../Utils/currencySign';

export const useInspection = ({ recordId, formId }) => {
  const { isLoading, setFormId, formEntity, getForm } = useForm(formId);
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const recordEntity = new Record(record);

  const source = useSelector((state) => state.reduxRecords.data[recordId]?.sourceInfos?.source);
  const history = useHistory();
  const active =
    formId && formEntity.canAccessForm(Auth.userId()) && !recordEntity.roleViewerAccessBloc(Auth.role(), 'appraisal');
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const recordStatus = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.statusId);
  const rKey = formEntity.recordKey();
  const rID = formEntity.recordId();
  const country = formEntity.country();
  const Name = country === 'ES' ? 'informe_estadoVO' : 'rapport_d_inspection';
  const downloadPdf = `${REACT_APP_API}/buyer/public/${source}/${rKey}/admin-documents/${rID}_${Name}.pdf`;
  const newPdfUrl = useSelector((state) => state?.reduxRecords?.data[recordId]?.vehicleExpertise?.pdfUrl);
  const destinations = useSelector((state) => state.reduxRecords.data[recordId])?.destinations;
  const date =
    (destinations?.[1]?.updateAt?.date && destinations?.[1]?.updateAt?.date) || destinations?.[1]?.createdAt?.date;

  const checkClickOrigin = (event) => {
    if (event.target.id !== 'theHref') {
      history.push({
        pathname: `/forms/${formId}`,
        state: {
          ...history.location.state,
          queries: `/files/${recordId}`,
        },
      });
    }
  };

  const goToInspection = (e) => {
    if (recordEntity.roleViewerAccessBloc(Auth.role(), 'appraisal')) return;
    if (
      !active ||
      (!formEntity?.checkUpdatedAtInspection() && originId && [1, 11].includes(originId) && recordStatus === 2)
    )
      return;
    checkClickOrigin(e);
  };

  useEffect(() => {
    setFormId(formId);
    getForm();
  }, [formId]);

  const formStatus = formEntity.status();
  const localStatus = formEntity.localStatus();
  let totals = formEntity.totals().map(({ referential, cost }) => ({
    label: t(referential),
    value: cost !== null ? currencySign(numStr(cost), null, country) : '',
  }));

  if (totals) {
    totals = hideTabs(totals, '', source);
    totals = totals.filter(Boolean);
    totals.sort((a, b) => {
      if (a.label === t('nrm_internal')) return -1;
      if (b.label === t('nrm_external')) return 1;
      return 0;
    });
  }

  const condiDisplayPdfLink = formEntity.inspectionReport() || recordEntity.inspectionReport();

  const showNewPdf = typeof newPdfUrl === 'string' && newPdfUrl.startsWith('https');
  return {
    goToInspection,
    active,
    isLoading,
    status: formStatus,
    totals,
    localStatus,
    downloadPdf,
    newPdfUrl,
    condiDisplayPdfLink,
    bee2LinkDate: date ? moment(date).format('DD/MM/YYYY') : false,
    message: t(dmsStatusList[destinations?.[1]?.status]),
    showNewPdf,
    recordStatus,
    recordType: recordEntity.type(),
  };
};
